var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    stroke: "#D8E1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6963 30.1974V29.8091H51.6003L51.4883 30.068L51.3763 29.8091H51.2803V30.1974H51.3443V29.9062L51.4563 30.1651H51.5363L51.6483 29.9062V30.1974H51.6963ZM51.0563 30.1974V29.8738H51.1843V29.8091H50.8643V29.8738H50.9923V30.1974H51.0563Z",
    fill: "#00A2E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3201 31.864H31.6641V16.1359H40.3201V31.864Z",
    fill: "#7375CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.224 24C32.224 20.8123 33.696 17.9644 36 16.1359C34.32 14.7929 32.192 14 29.888 14C24.432 14 20 18.4822 20 24C20 29.5178 24.432 34 29.888 34C32.192 34 34.32 33.2071 36 31.8641C33.696 30.0356 32.224 27.1877 32.224 24Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24C52 29.5178 47.568 34 42.112 34C39.808 34 37.68 33.2071 36 31.8641C38.304 30.0356 39.776 27.1877 39.776 24C39.776 20.8123 38.304 17.9644 36 16.1359C37.68 14.7929 39.808 14 42.112 14C47.568 14 52 18.4822 52 24Z",
    fill: "#00A2E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/Maestro.a20527b38eaa672dad924955462bae72.svg";
export { ForwardRef as ReactComponent };